import React from "react";
import UserLayout from "../../layouts/UserLayout";
const NewSurvey = () => {
  return (
    <>
      <UserLayout
        title={"New Survey"}
        content={
          "It is very important that the information on this page is complete and accurate in order to receive a survey"
        }
      >
        Hello World
      </UserLayout>
    </>
  );
};

export default NewSurvey;
